module.exports = __webpack_public_path__ + "static/media/SaintMaryoftheAnnunciationSchoolDanvers.9c4fda00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/SaintMaryoftheAnnunciationSchoolDanvers.png
// module id = 781
// module chunks = 0